export const load = (el, binding) => {
  el.classList.toggle('is-loading', binding.value);
  el.disabled = binding.value;
};
